import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { ParticipantApprovalService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetParticipantApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<any, unknown> => {
  const {
    employeeStatusId,
    employeeType,
    accountStatus,
    emailStatus,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    brokerAccountStatusIds,
    _force,
  } = tableInfo;

  const ParticipantList = useQuery(
    [
      'getParticipantApprovalList',
      brokerAccountStatusIds,
      employeeStatusId,
      employeeType,
      accountStatus,
      emailStatus,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        ParticipantApprovalService.getApiCustomerApiAppParticipantApprovalParticipantsList(
          employeeStatusId,
          employeeType,
          accountStatus,
          emailStatus,
          brokerAccountStatusIds,
          null,
          filter,
          sorting,
          skipCount,
          maxResultCount
        ).then((res: any) => ({
          ...res,
          items: res.items.map((participants: any) => ({
            ...participants,
            status: participants?.statusName,
          })),
        }))
      );
    }
  );

  return ParticipantList;
};

export default useGetParticipantApprovalList;
